import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { LayoutLoginComponent } from '../layouts/Login/login.component'
import { LoginComponent } from './pages/auth/login/login.component'
import { ForgotComponent } from './pages/auth/forgot/forgot.component'
import { LayoutMainComponent } from '../layouts/Main/main.component'
import { DashboardComponent } from './pages/dashboard/dashboard.component'
import { AuthGuard } from './guards/auth.guard'
import { NotFoundComponent } from './pages/404.component'

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'masters/collaborators',
  //   pathMatch: 'full',
  // },
  // {
  //   path: 'auth',
  //   component: LayoutLoginComponent,
  //   children: [
  //     { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  //     { path: 'forgot', component: ForgotComponent, data: { title: 'Restore Password' } },
  //   ],
  // },
  // {
  //   path: '',
  //   component: LayoutMainComponent,
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: DashboardComponent,
  //       canActivate: [AuthGuard],
  //       data: { title: 'Dashboard' },
  //     },
  //   ],
  // },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
